import { useState } from 'react';
import { Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import DietPlanForm from 'src/components/dietPlan/DietPlanForm';
import { addDietPlan, getDietPlans } from 'src/api/dietPlan';
import { dietPlanReducerAction } from 'src/redux/reducers/dietPlan';
import { logoutUser } from 'src/redux/actions'

const AddDietPlanModal = ({ handleCloseModal }) => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user, gymId } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const { updateDietPlans } = dietPlanReducerAction;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <Container maxWidth="sm"
    sx={{
        padding: '.8rem',
        backgroundColor: 'background.default',
        borderRadius: '10px'
      }}>
      <Formik
        initialValues={{
          name: '',
          diet: '',
          comments: '',
          prescribed_by: ''
        }}
        validationSchema={CONSTANTS.dietValidationSchema}
        onSubmit={async (values) => {
          values.gym_id = gymId;
          values.meals.forEach((meal, index) => {
            if (meal.id) {
              delete values.meals[index]?.id;
            }
          });
          try {
            dispatch(startLoading());
            const res = await addDietPlan(user, values);
            dispatch(stopLoading());
            const isError = res.status !== 200;
            const message = isError
              ? res?.message
              : 'Diet Plan Added Successfully';
            setSnackbarState({
              open: true,
              message: message,
              severity: isError ? 'error' : 'success'
            });
            if (!isError) {
              getDietPlans(user, gymId)
                .then((res) => {
                  if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
                    dispatch(logoutUser());
                  if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
                    dispatch(updateDietPlans(res.data?.dietPlans));
                  }
                  dispatch(stopLoading());
                  handleCloseModal()
                })
                .catch((err) => {
                  dispatch(stopLoading());
                  console.log(err);
                });
            }
          } catch (err) {
            dispatch(stopLoading());
            setSnackbarState({
              open: true,
              message: err.message,
              severity: 'error'
            });
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          touched,
          values
        }) => (
          <DietPlanForm
            errors={errors}
            handleBlur={handleBlur}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            setFieldValue={setFieldValue}
            isSubmitting={isSubmitting}
            touched={touched}
            values={values}
            heading={STRINGS.ADD_DIET_PLAN}
          />
        )}
      </Formik>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
    </Container>
  );
};

export default AddDietPlanModal;
